import './FloatingLessonBubbleJump.css';

export const FloatingLessonBubbleJump = () => {
  return (
    <div className="jump-bubble-wrapper">
      <div className="jump-label-box">SARI AICI?</div>
    </div>
  );
};
